<template>
  <v-row justify="center">
    <v-dialog
      v-model="confirmationDialog"
      persistent
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline text-black">
          {{ title }}
        </v-card-title>
        <v-card-text v-html="body" />
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            rounded
            @click="closeAndDisagree()"
          >
            {{ cancelLabel }}
          </v-btn>
          <v-btn
            :color="color"
            variant="text"
            rounded
            @click="closeAndAgree()"
          >
            {{ actionLabel }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'AppConfirmationDialog',
  computed: {
    ...mapState('dialog', [
      'confirmationDialog',
      'title',
      'body',
      'action',
      'actionLabel',
      'cancel',
      'cancelLabel',
      'color'
    ])
  },
  methods: {
    ...mapMutations('dialog', ['closeDialog']),

    /**
     * Hides the dialog and executes the action callback function.
     *
     */
    closeAndAgree () {
      this.closeDialog('confirmationDialog')
      if (this.action) this.action()
    },

    /**
     * Hides the dialog and executes the cancel callback function.
     *
     */
    closeAndDisagree () {
      this.closeDialog('confirmationDialog')
      if (this.cancel) this.cancel()
    }
  }
}
</script>
